// Loading.js
import React from 'react';
import { FaSpinner } from 'react-icons/fa'; // Importing the spinner icon from react-icons

const Loading = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <FaSpinner className="animate-spin text-blue-500 text-6xl mb-4" />
      <h2 className="text-xl font-semibold text-gray-700">Loading, please wait...</h2>
      <p className="text-gray-500">We are preparing something special for you.</p>
    </div>
  );
};

export default Loading;
